module.exports = __webpack_public_path__ + "static/img/avatar-09.de28ab6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar-09.jpg
// module id = 394f
// module chunks = 22